/**
 * Vue2官网响应式适配方案
 * 基准宽度：1440px，字体大小：16px
 * PC端缩放范围：1024px-1920px
 * 移动端断点：768px
 */

// 配置参数
const config = {
  designWidth: 1440,     // 设计基准宽度
  baseFontSize: 16,      // 基准字体大小（1rem = 16px）
  maxWidth: 1920,        // 最大宽度限制
  minWidth: 1024,        // 最小宽度限制
  mobileBreakpoint: 768, // 移动端断点
  debounceDelay: 250     // 防抖延迟(ms)
};

// 防抖函数
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// 响应式字体调整函数
function setRootFontSize() {
  // 获取当前屏幕宽度
  let screenWidth = document.documentElement.clientWidth;
  
  // 移动端处理
  if (screenWidth <= config.mobileBreakpoint) {
    // 移动端使用固定字体大小
    document.documentElement.style.fontSize = '14px';
    document.body.classList.add('mobile-view');
    document.body.classList.remove('pc-view');
    
    // 触发移动端变化事件
    window.dispatchEvent(new CustomEvent('responsiveChange', {
      detail: {
        screenWidth,
        isMobile: true,
        scaleRatio: 1,
        currentFontSize: 14
      }
    }));
    return;
  }
  
  // PC端处理
  document.body.classList.add('pc-view');
  document.body.classList.remove('mobile-view');
  
  // 限制屏幕宽度在最小和最大范围内
  if (screenWidth > config.maxWidth) {
    screenWidth = config.maxWidth;
  } else if (screenWidth < config.minWidth) {
    screenWidth = config.minWidth;
  }
  
  // 计算缩放比例
  const scale = screenWidth / config.designWidth;
  const currentFontSize = config.baseFontSize * scale;
  
  // 设置根元素字体大小
  document.documentElement.style.fontSize = currentFontSize + 'px';
  
  // 触发响应式变化事件
  window.dispatchEvent(new CustomEvent('responsiveChange', {
    detail: {
      screenWidth,
      isMobile: false,
      scaleRatio: scale,
      currentFontSize: currentFontSize
    }
  }));
}

// 初始化函数
function initResponsive() {
  // 设置初始字体大小
  setRootFontSize();
  
  // 监听窗口大小变化（使用防抖优化性能）
  window.addEventListener('resize', debounce(setRootFontSize, config.debounceDelay));
  
  // 监听页面可见性变化（解决浏览器最小化后尺寸计算问题）
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      setRootFontSize();
    }
  });
  
  console.log('Vue2响应式适配方案已初始化');
}

// 获取当前适配信息
function getResponsiveInfo() {
  const screenWidth = document.documentElement.clientWidth;
  const isMobile = screenWidth <= config.mobileBreakpoint;
  const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  
  return {
    screenWidth,
    isMobile,
    fontSize,
    config: { ...config } // 返回配置的副本，避免直接修改
  };
}

// 添加响应式变化监听器
function addResponsiveListener(callback) {
  window.addEventListener('responsiveChange', callback);
  return () => window.removeEventListener('responsiveChange', callback);
}

// 导出函数
export default {
  init: initResponsive,
  getInfo: getResponsiveInfo,
  addListener: addResponsiveListener,
  config: { ...config } // 导出配置的副本
};